import type { CoreStore, CoreUser } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update store details.
 *
 * @endpoint PUT /api/saas/me/store
 * @scope saas
 */
export async function updateStore(
  store?: Partial<CoreStore>
): Promise<CoreUser> {
  const response = await api.put('/api/saas/me/store', store)

  return response.data?.store ?? null
}
